import { initialUnitOverview } from './initialState';
import { evaluatedOverviewData, advancedMergeAndFilter } from '../utils/dashboardOverviewUtil';
import {
  UNITOVERVIEW_ERROR,
  SET_UNITOVERVIEW_SETTINGS,
  UNITOVERVIEW_IS_LOADING,
  SET_UNITOVERVIEW_DATA,
  UNITOVERVIEW_CLEANUP
} from '../constants/index';


const UnitOverviewReducer = (state = initialUnitOverview, action) => {
  const { payload, type } = action;

  switch (type) {
    case SET_UNITOVERVIEW_SETTINGS: {
      const { data } = payload;

      if (data.UnitOverview && data.UnitOverview.Dashboard && data.UnitOverview.Data) {
        data.UnitOverview.Dashboard = evaluatedOverviewData(data.UnitOverview, null);
      }
      return {
        ...state,
        UnitOverview: {
          ...data.UnitOverview,
          isLoading: data.isLoading,
          displayMessageCode: data.displayMessageCode,
          showBanner: data.showBanner,
          isOpSuccessful: data.isOpSuccessful
        }
      };
    }

    case UNITOVERVIEW_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        UnitOverview: {
          ...state.UnitOverview,
          isLoading: isLoading
        }
      };
    }

    case UNITOVERVIEW_ERROR: {
      const { data } = payload;
      return {
        ...state,
        UnitOverview: {
          ...state.UnitOverview,
          ...data
        }
      };
    }

    case SET_UNITOVERVIEW_DATA: {
      const { data } = payload;
      let overviewData = data.data && data.data.UnitOverview ? data.data.UnitOverview : {};

      let currentData = advancedMergeAndFilter(state.UnitOverview, overviewData, {
        hoursBack: 24,
        removeDuplicates: true,
        sortByTime: true,
        mergeStrategy: 'latest' // or 'current'
      });

      if (state.UnitOverview && state.UnitOverview.Dashboard && currentData.Data) {
        overviewData.Dashboard = evaluatedOverviewData(currentData, state.UnitOverview.Dashboard);
      }

      return {
        ...state,
        UnitOverview: {
          ...state.UnitOverview,
          Data: currentData.Data,
          isLoading: data.isLoading,
          displayMessageCode: data.displayMessageCode,
          showBanner: data.showBanner
        }
      };
    }

    case UNITOVERVIEW_CLEANUP: {
      //const { UnitOverview } = payload;
      return {
        ...state,
        UnitOverview: {
          ...payload
        }
      };
    }

    default:
      return state;
  }
};

export default UnitOverviewReducer;
